import moment from "moment";
// Card Number
export const getAdvertDate = (serverDate) => {
  return moment.utc(serverDate).local().format("DD-MM-YYYY");
};
